
import React from 'react';

const RepositoryHeader: React.FC = React.memo(() => {
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight">Compliance Repository</h1>
      <p className="text-muted-foreground">
        View and manage compliance documents and their associated rules.
      </p>
    </div>
  );
});

RepositoryHeader.displayName = 'RepositoryHeader';

export default RepositoryHeader;
